import "../../../src/main.css";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import StatusFilter from "./StatusFilter";
import CategoryFilter from "./CategoryFilter";
import SubCategoryFilter from "./SubCategoryFilter";
import Offcanvas from "react-bootstrap/Offcanvas";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import AssigneeFilter from "./AssigneeFilter";
import UpdateBulkAssignee from "./UpdateBulkAssignee";
import useAllTicketStore from "./all_tickets/store";
import DoctorCallAttemptFilter from './DoctorCallAttemptFilter';
import { useOrderSearchForTicket } from "modules/CreateTicket/store";

function DateFilter({ selectedCategory, selectedSubCategory, selectedStatus, setSelectedCategory, setSelectedSubCategory, setSelectedStatus, handleFilterClick, selectedAssignee, setSelectedAssignee, assigneeOptions, refresh, setRefresh, tab, doctorCallAttempt, setDoctorCallAttempt }) {
  const { fetchAllCrmCategories, allCrmCategories } = useOrderSearchForTicket();
  const { allAssigneeData, fetchAllActiveAssignee } = useAllTicketStore();
  const [activeAssignee, setActiveAssignee] = useState([]);

  useEffect(() => {
    if (allAssigneeData?.data?.assignees.length > 0) {
      const assigneeData = allAssigneeData?.data?.assignees;
      const assigneeOption = assigneeData.map((assignee) => ({ label: assignee.firstName, value: assignee.userId, }));
      setActiveAssignee(assigneeOption);
    }
  }, [allAssigneeData]);

  useEffect(() => { fetchAllActiveAssignee(); }, []);

  const handleClickFilter = () => {
    handleFilterClick();
    setShow(false);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if(_.isEmpty(allCrmCategories)) {
      fetchAllCrmCategories();
    }
    setShow(true)
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow} className="me-2 mt-2">
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fs-1">more filter options</div>
            </Tooltip>
          }
        >
          <span>+ more</span>
        </OverlayTrigger>
      </Button>
      <Offcanvas show={show} style={{ width: "30vw" }} onHide={handleClose} name={"Filter & Download"} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h2>Filter By</h2>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex flex-column gap-1">
            <DoctorCallAttemptFilter
              doctorCallAttempt={doctorCallAttempt}
              setDoctorCallAttempt={setDoctorCallAttempt}
            />
            <StatusFilter
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
            />
            <CategoryFilter
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
            <SubCategoryFilter
              selectedCategory={selectedCategory}
              selectedSubCategory={selectedSubCategory}
              setSelectedSubCategory={setSelectedSubCategory}
            />
            {tab === 'all' && <AssigneeFilter
              selectedCategory={selectedCategory}
              selectedSubCategory={selectedSubCategory}
              selectedAssignee={selectedAssignee}
              setSelectedAssignee={setSelectedAssignee}
              assigneeOptions={assigneeOptions}
            />}
            <Button
              variant="primary"
              className="mt-4"
              onClick={handleClickFilter}
            >
              Filter by Table Data
            </Button>
          </div>

          <div className="d-flex flex-column gap-1 mt-4">
            <UpdateBulkAssignee
              assigneeOptions={activeAssignee}
              setRefresh={setRefresh}
              refresh={refresh}
              handleClose={handleClose}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default DateFilter;
